"use strict";

exports.__esModule = true;
exports.default = void 0;
var _emotion = require("emotion");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactEmotion = _interopRequireWildcard(require("react-emotion"));
var _Button = _interopRequireDefault(require("../../atoms/Button"));
var _base = _interopRequireDefault(require("../../shared/base"));
var _font = _interopRequireDefault(require("../../shared/font"));
var _utils = require("../../shared/utils");
var _theme = _interopRequireDefault(require("../../theme"));
var _mediaQueries = _interopRequireDefault(require("../../shared/mediaQueries"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype.__proto__ = superClass && superClass.prototype;
  subClass.__proto__ = superClass;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var accent = /*#__PURE__*/
(0, _reactEmotion.css)({
  background: _theme.default.accentColor,
  '&:hover': {
    background: (0, _utils.shade)(_theme.default.accentColor, -0.1)
  }
});
var curve = function curve(_ref) {
  var _css;
  var curveLeft = _ref.curveLeft,
    curveRight = _ref.curveRight;
  return /*#__PURE__*/(
    (0, _reactEmotion.css)((_css = {
      borderTopLeftRadius: curveLeft ? 20 : 0,
      borderBottomLeftRadius: curveLeft ? 20 : 0,
      borderTopRightRadius: curveRight ? 20 : 0,
      borderBottomRightRadius: curveRight ? 20 : 0
    }, _css[(0, _mediaQueries.default)('xs')] = {
      minWidth: 'auto'
    }, _css))
  );
};
var Inactive = /*#__PURE__*/
(0, _reactEmotion.default)('button', {
  target: "e1fjl25s0"
})(_base.default, _font.default, {
  background: '#86DDF8',
  color: '#052B37',
  border: 0,
  borderRadius: '3px 0 0 3px',
  // make rounder
  padding: '8px 16px',
  cursor: 'pointer',
  fontSize: '0.9rem',
  fontWeight: 600
}, curve);
var ToggleButton = /*#__PURE__*/
function (_Component) {
  function ToggleButton() {
    var _temp, _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_temp = _this = _Component.call.apply(_Component, [this].concat(args)) || this, _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      value: _this.props.defaultValue
    }), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (index) {
      var value = _this.state.value;
      var onChange = _this.props.onChange;
      if (value !== index) {
        _this.setState({
          value: index
        });
        if (onChange) {
          onChange(index);
        }
      }
    }), _temp) || _assertThisInitialized(_this);
  }
  var _proto = ToggleButton.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var value = this.state.value;
    var _this$props = this.props,
      options = _this$props.options,
      className = _this$props.className,
      style = _this$props.style;
    return _react.default.createElement("div", {
      className: className,
      style: style
    }, options.map(function (option, index) {
      var curveLeft = index === 0;
      var curveRight = index === options.length - 1;
      return index === value ? _react.default.createElement(_Button.default, {
        key: option,
        big: true,
        shadow: true,
        bold: true,
        className: (0, _emotion.css)((0, _reactEmotion.cx)(curve({
          curveLeft: curveLeft,
          curveRight: curveRight
        }), accent)),
        onClick: function onClick() {
          return _this2.handleClick(index);
        }
      }, option) : _react.default.createElement(Inactive, {
        key: option,
        curveLeft: curveLeft,
        curveRight: curveRight,
        onClick: function onClick() {
          return _this2.handleClick(index);
        }
      }, option);
    }));
  };
  _inheritsLoose(ToggleButton, _Component);
  return ToggleButton;
}(_react.Component);
ToggleButton.defaultProps = {
  defaultValue: 0
};
ToggleButton.propTypes = {
  style: _propTypes.object,
  className: _propTypes.string,
  options: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  defaultValue: _propTypes.number,
  onChange: _propTypes.func
};
var _default = ToggleButton;
exports.default = _default;